import 'url-polyfill'

window.addEventListener('DOMContentLoaded', () => {
  const changeTab = (cssClassName, tabNo, tabName) => {
    const fairAnchorBlock = document.getElementById('fair-anchor-block')

    if (tabName == 'description') {
      fairAnchorBlock.style.display = 'flex'
    } else if (tabName != 'inner') {
      fairAnchorBlock.style.display = 'none'
    }

    const cssClassNameArr = Array.prototype.slice.call(document.querySelectorAll(`.${cssClassName}`))
    cssClassNameArr.forEach((el) => {
      const currentTabNo = el.dataset.tabNo
      const span = el.querySelector('span')
      const a = el.querySelector('a')
      if (currentTabNo === tabNo) {
        span.style.display = 'flex'
        a.style.display = 'none'
      } else {
        span.style.display = 'none'
        a.style.display = 'flex'
      }
    })
    const cssClassNameContentsArr = Array.prototype.slice.call(document.querySelectorAll(`.${cssClassName}-contents`))
    cssClassNameContentsArr.forEach((el) => {
      const currentTabNo = el.dataset.tabNo
      if (currentTabNo === tabNo) {
        el.style.display = 'block'
      } else {
        el.style.display = 'none'
      }
    })
  }

  let url = new URL(window.location.href);
  let tabNoParam = url.searchParams.get("tab_no");
  const firstTabNo = document.querySelector('.fair-tab').dataset.tabNo
  const defaultTabNo = tabNoParam ? tabNoParam : firstTabNo
  const defaultInnerTabNo = '0'
  const firstTabName = document.querySelector('.fair-tab').dataset.tabName
  changeTab('fair-tab', defaultTabNo, firstTabName)
  changeTab('fair-inner-tab', defaultInnerTabNo, 'inner')
  const fairTabArr = Array.prototype.slice.call(document.querySelectorAll('.fair-tab a'))
  fairTabArr.forEach((el) => {
    el.addEventListener('click', (e) => {
      const tabNo = e.target.parentNode.dataset.tabNo
      const tabName = e.target.parentNode.dataset.tabName
      changeTab('fair-tab', tabNo, tabName)
    })
  })
  const fairInnerTabArr = Array.prototype.slice.call(document.querySelectorAll('.fair-inner-tab a'))
  fairInnerTabArr.forEach((el) => {
    el.addEventListener('click', (e) => {
      const tabNo = e.target.parentNode.dataset.tabNo
      changeTab('fair-inner-tab', tabNo, 'inner')
    })
  })
})
